import React, { Component } from "react";
import { Form, Input, Button, Card } from "reactstrap";
import { postData } from "../utils/fetch-requests";

class ForgotPasswordPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      submitted: false,
      message: "",
    };
  }

  handleChange = (e) => {
    this.setState({ email: e.target.value });
  };

  submit = () => {
    postData("/api/user/forgot-password", { email: this.state.email })
      .then((res) => {
        this.setState({
          submitted: true,
          message:
            (res && res.message) ||
            "If an account exists for that email, a reset link is on its way.",
        });
      })
      .catch(() => {
        // Show the same generic message even on a network error.
        this.setState({
          submitted: true,
          message:
            "If an account exists for that email, a reset link is on its way.",
        });
      });
  };

  render() {
    return (
      <div className="d-flex h-100 justify-content-center justify-content-middle text-center">
        <div className="col-md-3" style={{ marginTop: "10%" }}>
          <Card className="p-3 card-shadow">
            <div className="align-self-center">
              <img
                src="https://cdn.rynoss.com/wp-content/themes/rynoss/assets/images/RYNOSS-logo.png"
                alt=""
              />
            </div>
            {this.state.submitted ? (
              <div className="col-12">
                <h5 className="text-muted">{this.state.message}</h5>
                <a href="/login">Back to login</a>
              </div>
            ) : (
              <div className="col-12">
                <h5 className="text-muted">
                  Enter your email and we'll send you a reset link.
                </h5>
                <Form>
                  <Input
                    id="email"
                    className="form-control mb-1"
                    placeholder="E-mail address"
                    value={this.state.email}
                    onChange={this.handleChange}
                  />
                </Form>
                <Button
                  className="ryno-orange-bg"
                  block
                  onClick={this.submit}
                >
                  Send reset link
                </Button>
                <a href="/login" className="d-block mt-2">
                  Back to login
                </a>
              </div>
            )}
          </Card>
        </div>
      </div>
    );
  }
}

export default ForgotPasswordPage;
